export interface ISplitDetailOrder {
  /** 订单号 */
  id: string;
  /** 分账账号 */
  payeeAccountNo: string;
  /** 分账户名 */
  payeeAccountName: string;
  /** 企业名称 */
  companyName: string;
  /** 代理商名称 */
  agentName: string;
  /** 分账接收方 */
  payeeName: string;
  /** 通道 */
  channelName: string;
  /** 分账时间 */
  createTime: string;
  /** 分账状态 */
  subOrderStatus: ESplitDetailOrderStatus;
  /** 分账金额（元） */
  settlementAmount: string;
}

export interface ISplitDetailOrderParam {
  /** 订单号 */
  id?: string;
  /** 分账接收方 */
  payeeName?: string;
  /** 分账时间（起） */
  startTime?: string;
  /** 分账时间（止） */
  endTime?: string;
  /** 分账状态 */
  subOrderStatus?: ESplitDetailOrderStatus;
  /** 企业名称 */
  companyId?: string;
    /** 代理商名称 */
  agentId?: string;
  page: number;
  size: number;
}

export enum ESplitDetailOrderStatus {
    /** 待支付 */
    WaitPay = 4,
    /** 已取消 */
  Cancelled = 5,
  /** 分账中 */
  InProgress = 3,
  /** 失败 */
  Failed = 1,
  /** 成功 */
  Succeed = 0,
}

export const splitDetailOrderStatusLabel = {
  [ESplitDetailOrderStatus.WaitPay]: '待支付',
  [ESplitDetailOrderStatus.Cancelled]: '已取消',
  [ESplitDetailOrderStatus.InProgress]: '分账中',
  [ESplitDetailOrderStatus.Failed]: '失败',
  [ESplitDetailOrderStatus.Succeed]: '成功',
};

export const splitDetailOrderStatusStyle = {
  [ESplitDetailOrderStatus.WaitPay]: 'warning',
  [ESplitDetailOrderStatus.Cancelled]: 'info',
  [ESplitDetailOrderStatus.InProgress]: 'warning',
  [ESplitDetailOrderStatus.Failed]: 'danger',
  [ESplitDetailOrderStatus.Succeed]: 'success',
};

export enum EDepositStatus {
  /** 待入账 */
  Action = 1,
  /** 成功 */
  Succeed = 0,
}

export const depositStatusLabel = {
  [EDepositStatus.Action]: '待入账',
  [EDepositStatus.Succeed]: '成功',
};

export const depositStatusStyle = {
  [EDepositStatus.Action]: 'danger',
  [EDepositStatus.Succeed]: 'success',
};
